import { redirect } from "@organizacaox/lai-design-system/router";

// "badges" saiu em 2026-10-13: os prazos favoritos agora ficam em cada Selo.
export type BrandingTab =
  | "basic"
  | "theme"
  | "login"
  | "app"
  | "showcase"
  | "profile-fields"
  | "forms";
export const BRANDING_SECTIONS = [
  {
    tab: "basic",
    label: "Informações básicas",
    capability: "branding.read",
    description: "Defina os dados e as preferências da sua marca.",
  },
  {
    tab: "theme",
    label: "Tema",
    capability: "branding.read",
    description: "Defina o tema padrão, as cores e a identidade visual da organização.",
  },
  {
    tab: "login",
    label: "Tela de login",
    capability: "branding.read",
    description: "Configure a apresentação da tela de login.",
  },
  {
    tab: "app",
    label: "Aplicativo",
    capability: "branding.read",
    description: "Personalize a identidade do aplicativo instalado.",
  },
  {
    tab: "forms",
    label: "Formulários",
    capability: "branding.read",
    description: "Crie formulários de boas-vindas e diagnóstico para os membros.",
  },
  {
    tab: "profile-fields",
    label: "Campos de perfil",
    capability: "branding.read",
    description: "Configure as informações adicionais dos membros da comunidade.",
  },
  {
    tab: "showcase",
    label: "Vitrine",
    capability: "content.showcases.read",
    description: "Organize as vitrines que apresentam seus conteúdos.",
  },
] as const;
const tabs: readonly string[] = BRANDING_SECTIONS.map((section) => section.tab);
export const brandingHref = (tab: BrandingTab) => `/admin/branding?tab=${tab}`;

// O AppShell recebe href; o Link do roteador recebe pathname e search separados.
export function brandingLinkOptions(href: string) {
  const section = BRANDING_SECTIONS.find((item) => brandingHref(item.tab) === href);
  return section ? { to: "/admin/branding" as const, search: { tab: section.tab } } : undefined;
}

export function brandingSearch(search: Record<string, unknown>): { tab?: BrandingTab } {
  return typeof search.tab === "string" && tabs.includes(search.tab)
    ? { tab: search.tab as BrandingTab }
    : {};
}

export function redirectLegacyShowcases() {
  throw redirect({ to: "/admin/branding", search: { tab: "showcase" }, replace: true });
}

export function redirectLegacyShowcase({ params }: { params: { id: string } }) {
  throw redirect({ to: "/admin/branding/vitrine/$id", params: { id: params.id }, replace: true });
}
